import React from 'react';
import './offlineDisplay.css';
const OfflineDisplay = ({ status, message, buttonColor, colors, title, subtitle }) => {
  return (
    <div>
      <div style={{ backgroundColor: buttonColor, color: colors }} className="rcw-header">
        <h4 className="rcw-title">{title}</h4>
        <span>{subtitle}</span>
      </div>
      <div className="display-body">
        <img
          className="body-image"
          src="./images/customer-offline.svg"
          alt=""
          height={138}
          width={182}
        />
        <p className="body-status">{status}</p>
        <p className="body-message">{message}</p>
      </div>
    </div>
  );
};

export default OfflineDisplay;
